import './style.scss';
import changePasswordForm from "./changePasswordForm";
import Alert from "../../components/common/alert";
import EditProfile from "../myProfile/editProfile";
import {clearChangePasswordErrors, clearUserFormErrors} from "../../actions/users";
import ViewProfile from "../myProfile/viewProfile";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import ChangePasswordForm from "./changePasswordForm";
import {Navigate} from "react-router-dom";
import {route as MY_PROFILE_ROUTE} from "../myProfile";
import {MESSAGES} from "../../constants";

export const route = 'change-password';

const ChangePassword = () => {
  const dispatch = useDispatch();

  const currentUser = useSelector((state) => state.session.currentUser);
  const changePasswordApiErrors = useSelector((state) => state.users.changePasswordApiErrors);
  const changePasswordSuccess = useSelector((state) => state.users.changePasswordSuccess);

  const onDismissAlert = () => {
    dispatch(clearChangePasswordErrors());
  }

  return (changePasswordSuccess) ? <Navigate to="/my-profile"/> : (
    <div className='main-content'>
      <div className='my-profile-header'>Set Your Own Password, {currentUser.firstName}!</div>
      <div className='change-password-alerts'>
        {(changePasswordApiErrors) && <Alert messageType='error' onDismiss={onDismissAlert}>{MESSAGES.USERS.changePasswordError}</Alert>}
      </div>
      <div className='my-profile-container'>
        <div className='my-info-content'>
          <ChangePasswordForm changePasswordUser={currentUser}/>
        </div>
      </div>
    </div>
  )

}

export default ChangePassword;